import { PoweredByMeitre } from '@shared/components/common';

const BookingFooter = () => (
  <footer className="hidden lg:block py-6 text-center bg-foreground/5">
    <div className="text-xs">
      <PoweredByMeitre />
    </div>
  </footer>
);

export default BookingFooter;
